export default "__VITE_ASSET__CKJkzk4s__"